import React from 'react';

function SideBar() {
  const userType = localStorage.getItem("userType");
  const userId = localStorage.getItem("userId");
  return (
    <div className="sideBar" style={{ width: '250px' }}>
      <div className="sidebar" data-background-color="dark">

        <div className="logo-header" data-background-color="dark">
          <a href="/admin/dashboard" className="logo">
            <img src="/assets/img/logo1.png" alt="navbar brand" className="navbar-brand" height="50" width="100" />
          </a>
        </div>

        <div className="sidebar-wrapper scrollbar scrollbar-inner">
          <div className="sidebar-content">
            <ul className="nav nav-secondary">

              {/* Dashboard – always visible */}
              <li className="nav-item">
                <a href="/admin/dashboard">
                  <i className="fas fa-home"></i>
                  <p>Dashboard</p>
                </a>
              </li>

              {/* Banner – Admin only */}
              {userType === "1" && (
                <li className="nav-item">
                  <a data-bs-toggle="collapse" href="#banner">
                    <i className="fa-solid fa-image"></i>
                    <p>Banner</p>
                  </a>
                  <div className="collapse" id="banner">
                    <ul className="nav nav-collapse">
                      <li><a href="/admin/bannerList"><span className="sub-item">List</span></a></li>
                    </ul>
                  </div>
                </li>
              )}

              {/* Property – Admin only */}

              <li className="nav-item">
                <a data-bs-toggle="collapse" href="#property">
                  <i className="fa-solid fa-house-user"></i>
                  <p>Property</p>
                </a>
                <div className="collapse" id="property">
                  <ul className="nav nav-collapse">
                    <li><a href="/admin/propertyList"><span className="sub-item">List</span></a></li>
                  </ul>
                </div>
              </li>


              {/* User – Admin only */}
              {userType === "1" && (
                <li className="nav-item">
                  <a data-bs-toggle="collapse" href="#user">
                    <i className="fa-solid fa-users"></i>
                    <p>User</p>
                  </a>
                  <div className="collapse" id="user">
                    <ul className="nav nav-collapse">
                      <li><a href="/admin/userList"><span className="sub-item">List</span></a></li>
                    </ul>
                  </div>
                </li>
              )}
              {/* User – Admin only */}
              {userType === "1" && (
                <li className="nav-item">
                  <a data-bs-toggle="collapse" href="#contactUs">
                    <i className="fa-solid fa-database"></i>
                    <p>Contact Us</p>
                  </a>
                  <div className="collapse" id="contactUs">
                    <ul className="nav nav-collapse">
                      <li><a href="/admin/contactList"><span className="sub-item">List</span></a></li>
                    </ul>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
